import type { LanguagePack } from './types'

export const ml: LanguagePack = {
  navSaved: 'സേവ് ചെയ്തവ',
  navInfo: 'വിവരം',
  homeTitle: 'നിങ്ങളുടെ കടലാസിന്റെ ഫോട്ടോ എടുക്കൂ',
  homeHint: 'അതിൽ എന്താണ് എഴുതിയിരിക്കുന്നതെന്നും, ഇനി നിങ്ങൾ എന്തു ചെയ്യണമെന്നും സമ്ഝോ പറഞ്ഞുതരും.',
  takePhoto: 'ഫോട്ടോ എടുക്കൂ',
  uploadFile: 'ഫോട്ടോ അല്ലെങ്കിൽ PDF അപ്‌ലോഡ് ചെയ്യൂ',
  supportedFiles: 'ഫോട്ടോ (JPG, PNG, WEBP) അല്ലെങ്കിൽ PDF · 10 MB വരെ',
  chooseLanguage: 'ഏതു ഭാഷയിൽ വിശദീകരിക്കണം',
  privacyLine: 'നിങ്ങളുടെ കടലാസ് ഈ ഫോണിൽ തന്നെയാണ് വായിക്കുന്നത്. "സേവ് ചെയ്യൂ" അമർത്തിയാൽ മാത്രമേ ഇത് സേവ് ആകൂ.',

  previewTitle: 'ഫോട്ടോ ശരിയാണോ?',
  rotate: 'തിരിക്കൂ',
  crop: 'മുറിക്കൂ',
  cropDone: 'കഴിഞ്ഞു',
  retake: 'വീണ്ടും എടുക്കൂ',
  readNow: 'വായിക്കൂ',
  docLanguageLabel: 'കടലാസ് ഏതു ഭാഷയിലാണ് എഴുതിയിരിക്കുന്നത്?',
  docLanguageHint: 'ഇംഗ്ലീഷും എപ്പോഴും കൂടെ വായിക്കും.',

  stepCheck: 'ഫോട്ടോ പരിശോധിക്കുന്നു…',
  stepRead: 'കടലാസ് വായിക്കുന്നു…',
  stepExtract: 'പ്രധാന വിവരങ്ങൾ കണ്ടെത്തുന്നു…',
  stepExplain: 'മലയാളത്തിൽ വിശദീകരിക്കുന്നു…',
  firstTimeNote: 'ആദ്യത്തെ തവണ വായിക്കാനുള്ള ടൂൾ ഡൗൺലോഡ് ആകുന്നതുകൊണ്ട് കുറച്ചു കൂടുതൽ സമയം എടുക്കും.',
  cancel: 'റദ്ദാക്കൂ',

  errBadImage: 'ഫോട്ടോ അത്ര വ്യക്തമല്ല. ദയവായി വ്യക്തമായ മറ്റൊരു ഫോട്ടോ എടുക്കൂ.',
  errNoText: 'ഈ കടലാസിൽ എഴുതിയതൊന്നും സമ്ഝോയ്ക്ക് കണ്ടെത്താനായില്ല.',
  errUnclearPart: 'ഈ ഭാഗം സമ്ഝോയ്ക്ക് ശരിയായി വായിക്കാനായില്ല.',
  errUnsupportedLanguage: 'ഈ ഭാഷയ്ക്ക് ഇതുവരെ സപ്പോർട്ട് ഇല്ല.',
  errLongDocument: 'ഈ കടലാസ് കുറച്ചു നീളമുള്ളതാണ്. ആദ്യം പ്രധാനപ്പെട്ട പേജുകൾ തിരഞ്ഞെടുക്കൂ.',
  errFileType: 'ദയവായി ഫോട്ടോ (JPG, PNG, WEBP) അല്ലെങ്കിൽ PDF തിരഞ്ഞെടുക്കൂ.',
  errFileSize: 'ഈ ഫയൽ 10 MB-യിൽ കൂടുതലാണ്. ദയവായി ചെറിയ ഫയൽ തിരഞ്ഞെടുക്കൂ.',
  errGeneric: 'എന്തോ പ്രശ്നം ഉണ്ടായി. ദയവായി വീണ്ടും ശ്രമിക്കൂ.',
  errOcrDownload: 'വായിക്കാനുള്ള ടൂൾ ഡൗൺലോഡ് ആയില്ല. ഒരു തവണ ഇന്റർനെറ്റ് ഓൺ ചെയ്ത് വീണ്ടും ശ്രമിക്കൂ.',
  warnDark: 'ഫോട്ടോയിൽ വെളിച്ചം കുറവാണ്. നല്ല വെളിച്ചത്തിൽ എടുത്ത ഫോട്ടോ നന്നായി വായിക്കാം.',
  warnBlurry: 'ഫോട്ടോ മങ്ങിയിരിക്കുന്നു. ഫോൺ അനങ്ങാതെ പിടിച്ച് വീണ്ടും എടുക്കൂ.',
  warnSmall: 'ഫോട്ടോ വളരെ ചെറുതാണ്. കടലാസിന്റെ അടുത്തുനിന്ന് എടുക്കൂ.',
  tryAgain: 'വീണ്ടും ശ്രമിക്കൂ',

  pickPagesHint: (max) => `${max} പേജുകൾ വരെ തിരഞ്ഞെടുക്കൂ.`,
  pageLabel: (n) => `പേജ് ${n}`,
  readSelectedPages: (n) => (n === 1 ? '1 പേജ് വായിക്കൂ' : `${n} പേജുകൾ വായിക്കൂ`),

  typeSure: (name) => `ഇത് ${name} ആണെന്ന് തോന്നുന്നു.`,
  typeMaybe: (name) => `ഇത് ${name} ആയിരിക്കാം, പക്ഷേ സമ്ഝോയ്ക്ക് പൂർണ്ണമായി ഉറപ്പില്ല.`,
  typeUnknown: 'ഇത് ഏതു തരം കടലാസാണെന്ന് സമ്ഝോയ്ക്ക് പൂർണ്ണമായി ഉറപ്പില്ല.',
  docTypes: {
    income_certificate: { name: 'വരുമാന സർട്ടിഫിക്കറ്റ്', about: 'സർക്കാർ രേഖകൾ പ്രകാരം ഒരാളുടെയോ കുടുംബത്തിന്റെയോ വരുമാനം ഇതിൽ എഴുതിയിരിക്കും.' },
    caste_certificate: { name: 'ജാതി സർട്ടിഫിക്കറ്റ്', about: 'ഒരാൾ ഏതു ജാതിയിലോ വിഭാഗത്തിലോ പെട്ടതാണെന്ന് ഇതിൽ എഴുതിയിരിക്കും.' },
    domicile_certificate: { name: 'താമസ സർട്ടിഫിക്കറ്റ്', about: 'ഒരാൾ സ്ഥിരമായി എവിടെയാണ് താമസിക്കുന്നതെന്ന് ഇതിൽ എഴുതിയിരിക്കും.' },
    birth_certificate: { name: 'ജനന സർട്ടിഫിക്കറ്റ്', about: 'ഇത് ഒരു ജനനത്തിന്റെ സർക്കാർ രേഖയാണ്.' },
    death_certificate: { name: 'മരണ സർട്ടിഫിക്കറ്റ്', about: 'ഇത് ഒരു മരണത്തിന്റെ സർക്കാർ രേഖയാണ്.' },
    electricity_bill: { name: 'കറന്റ് ബിൽ', about: 'ഉപയോഗിച്ച കറന്റും അടയ്ക്കേണ്ട തുകയും ഇതിൽ ഉണ്ടാകും.' },
    water_bill: { name: 'വാട്ടർ ബിൽ (വെള്ളക്കരം)', about: 'അടയ്ക്കേണ്ട വെള്ളക്കരം ഇതിൽ ഉണ്ടാകും.' },
    ration_card: { name: 'റേഷൻ കാർഡ് അല്ലെങ്കിൽ റേഷൻ അറിയിപ്പ്', about: 'ഇത് സർക്കാർ റേഷൻ കടയിൽ നിന്ന് റേഷൻ വാങ്ങുന്നതിനെക്കുറിച്ചാണ്.' },
    aadhaar: { name: 'ആധാറുമായി ബന്ധപ്പെട്ട കടലാസ്', about: 'ഇത് ആധാർ നമ്പറിനെക്കുറിച്ചോ ആധാർ വിവരങ്ങളെക്കുറിച്ചോ ആണ്.' },
    pan_card: { name: 'പാനുമായി ബന്ധപ്പെട്ട കടലാസ്', about: 'ഇത് പാൻ (ടാക്സ് തിരിച്ചറിയൽ) നമ്പറിനെക്കുറിച്ചാണ്.' },
    bank_notice: { name: 'ബാങ്ക് കത്ത്', about: 'ഇത് ബാങ്കിൽ നിന്നുള്ള കത്തോ അറിയിപ്പോ ആണ്.' },
    loan_notice: { name: 'വായ്പ (ലോൺ) അറിയിപ്പ്', about: 'ഇത് ഒരു ലോണിനെക്കുറിച്ചോ കുടിശ്ശികയുള്ള പണത്തെക്കുറിച്ചോ ആണ്.' },
    income_tax_notice: { name: 'ആദായ നികുതി (ഇൻകം ടാക്സ്) നോട്ടീസ്', about: 'ഇത് ആദായ നികുതി വകുപ്പിൽ നിന്നുള്ളതാണ്.' },
    pension: { name: 'പെൻഷൻ കത്ത്', about: 'ഇത് പെൻഷനെക്കുറിച്ചാണ്.' },
    court_notice: { name: 'കോടതി അല്ലെങ്കിൽ നിയമ നോട്ടീസ്', about: 'ഇത് കോടതിയിൽ നിന്നുള്ളതാണ്, അല്ലെങ്കിൽ ഒരു നിയമപ്രശ്നത്തെക്കുറിച്ചാണ്. ഇതിനെ നിസ്സാരമായി കാണരുത്.' },
    land_record: { name: 'ഭൂമി രേഖ', about: 'ഇത് ഭൂമി ആരുടേതാണ് എന്നതിനെക്കുറിച്ചോ ഭൂമിയുടെ വിവരങ്ങളെക്കുറിച്ചോ ആണ്.' },
    property_tax: { name: 'കെട്ടിട നികുതി (വീട്ടുകരം) ബിൽ', about: 'ഇത് വീടിന്റെയോ സ്വത്തിന്റെയോ നികുതിയെക്കുറിച്ചാണ്.' },
    scholarship: { name: 'സ്കോളർഷിപ്പ് കത്ത്', about: 'ഇത് പഠനത്തിനുള്ള സ്കോളർഷിപ്പിനെക്കുറിച്ചാണ്.' },
    farmer_scheme: { name: 'കർഷക പദ്ധതി കത്ത്', about: 'ഇത് കർഷകർക്കുള്ള ഒരു പദ്ധതിയെക്കുറിച്ചോ സഹായത്തെക്കുറിച്ചോ ആണ്.' },
    school_letter: { name: 'സ്കൂൾ കത്ത്', about: 'ഇത് സ്കൂളിൽ നിന്നുള്ളതാണ്, അല്ലെങ്കിൽ പഠനത്തെക്കുറിച്ചാണ്.' },
    marksheet: { name: 'മാർക്ക് ലിസ്റ്റ് അല്ലെങ്കിൽ റിസൾട്ട്', about: 'ഇതിൽ പരീക്ഷയുടെ മാർക്കോ റിസൾട്ടോ ഉണ്ട്.' },
    insurance: { name: 'ഇൻഷുറൻസ് കടലാസ്', about: 'ഇത് ഒരു ഇൻഷുറൻസ് പോളിസിയെക്കുറിച്ചാണ്.' },
    traffic_challan: { name: 'ട്രാഫിക് ചലാൻ (പിഴ)', about: 'ഇത് ട്രാഫിക് അല്ലെങ്കിൽ വാഹന നിയമവുമായി ബന്ധപ്പെട്ട പിഴയാണ്.' },
    job_notice: { name: 'ജോലി അല്ലെങ്കിൽ പരീക്ഷാ അറിയിപ്പ്', about: 'ഇത് സർക്കാർ ജോലി, നിയമനം അല്ലെങ്കിൽ അതിനുള്ള പരീക്ഷയെക്കുറിച്ചാണ്.' },
    application_receipt: { name: 'അപേക്ഷയുടെ രസീത്', about: 'അപേക്ഷ കിട്ടിയിട്ടുണ്ടെന്ന് ഇത് കാണിക്കുന്നു.' },
    application_decision: { name: 'അപേക്ഷയെക്കുറിച്ചുള്ള കത്ത്', about: 'ഇതിൽ ഒരു അപേക്ഷയെക്കുറിച്ചുള്ള തീരുമാനമോ വിവരമോ ഉണ്ട്.' },
    government_notice: { name: 'സർക്കാർ അറിയിപ്പ്', about: 'ഇത് ഒരു സർക്കാർ ഓഫീസിൽ നിന്നുള്ള അറിയിപ്പോ ഉത്തരവോ ആണ്.' },
    lab_report: { name: 'മെഡിക്കൽ പരിശോധനാ റിപ്പോർട്ട്', about: 'ഇതിൽ രക്തത്തിന്റെയോ മറ്റ് മെഡിക്കൽ പരിശോധനകളുടെയോ ഫലങ്ങളുണ്ട്.' },
    rental_agreement: { name: 'വാടക കരാർ', about: 'ഇത് വീട്ടുടമയും വാടകക്കാരനും തമ്മിലുള്ള കരാറാണ്.' },
    loan_agreement: { name: 'വായ്പാ കരാർ', about: 'ഇതിൽ വായ്പയുടെ വ്യവസ്ഥകളുണ്ട്: പലിശ, EMI, ചാർജുകൾ.' },
    contract: { name: 'ഒരു കരാർ', about: 'ഇരുകൂട്ടരും പാലിക്കേണ്ട വ്യവസ്ഥകളുള്ള ഒരു കരാറാണിത്.' },
    unknown: { name: 'കടലാസ്', about: '' }
  },

  seedhiBaat: 'ലളിതമായി പറഞ്ഞാൽ',
  docSays: 'കടലാസിൽ ഉള്ളത്',
  samjhoSays: 'സമ്ഝോ പറയുന്നത്',
  unclearText: 'ഈ ഭാഗം വ്യക്തമല്ല — ദയവായി ഒറിജിനൽ കടലാസ് നോക്കൂ.',

  aboutPerson: (name) => `ഈ കടലാസ് ഇവരെക്കുറിച്ചാണ്: ${name}.`,
  issuedBy: (authority) => `ഇത് ഇവിടെ നിന്നാണ്: ${authority}.`,
  status: {
    approved: 'അപേക്ഷ അംഗീകരിച്ചു.',
    rejected: 'അപേക്ഷ നിരസിച്ചു (റിജക്ട് ചെയ്തു).',
    pending: 'അപേക്ഷ ഇപ്പോഴും നടപടിയിലാണ്. ഇതുവരെ തീരുമാനം ആയിട്ടില്ല.',
    cancelled: 'ഇത് റദ്ദാക്കി.'
  },
  dateSentence: {
    deadline: (d) => `അവസാന തീയതി: ${d}.`,
    due: (d) => `പണം അടയ്ക്കാനുള്ള അവസാന തീയതി: ${d}.`,
    hearing: (d) => `ഹാജരാകാൻ കടലാസിൽ കൊടുത്തിരിക്കുന്ന തീയതി: ${d}.`,
    issue: (d) => `ഇത് ${d} ന് നൽകിയതാണ്.`,
    validity: (d) => `ഇതിന് ${d} വരെ സാധുതയുണ്ട്.`,
    birth: (d) => `എഴുതിയിരിക്കുന്ന ജനന തീയതി: ${d}.`,
    other: (d) => `ഒരു തീയതി എഴുതിയിട്ടുണ്ട്: ${d}.`
  },
  daysLeft: (days) => `ഇനി ${days} ദിവസം ബാക്കിയുണ്ട്.`,
  dueToday: 'ഈ തീയതി ഇന്നാണ്.',
  datePassed: 'ശ്രദ്ധിക്കൂ: ഈ തീയതി കഴിഞ്ഞുപോയി.',
  amountSentence: {
    payable: (a) => `അടയ്ക്കേണ്ട തുക: ${a}.`,
    income: (a) => `എഴുതിയിരിക്കുന്ന വരുമാനം: ${a}.`,
    fine: (a) => `എഴുതിയിരിക്കുന്ന പിഴ അല്ലെങ്കിൽ വൈകിയതിനുള്ള ഫീസ്: ${a}.`,
    fee: (a) => `എഴുതിയിരിക്കുന്ന ഫീസ്: ${a}.`,
    sanctioned: (a) => `അനുവദിച്ചതോ അയച്ചതോ ആയ തുക: ${a}.`,
    other: (a) => `ഒരു തുക എഴുതിയിട്ടുണ്ട്: ${a}.`
  },
  actionsPointer: 'കടലാസിൽ നിങ്ങളോട് എന്തോ ചെയ്യാൻ പറയുന്നുണ്ട്. താഴെ "നിങ്ങൾ ചെയ്യേണ്ടത്" നോക്കൂ.',
  noActionFound: 'നിങ്ങൾ എന്തെങ്കിലും ചെയ്യണമെന്ന് കടലാസിൽ വ്യക്തമായി പറയുന്നില്ല.',
  keepSafe: 'ഈ കടലാസ് സൂക്ഷിച്ചു വെക്കൂ.',
  doBefore: (d) => `ഇത് ${d} തീയതിക്കു മുമ്പ് ചെയ്യൂ.`,
  bringDocs: (list) => `ഈ കടലാസുകൾ തയ്യാറാക്കി വെക്കൂ: ${list}.`,
  contactFor: (c) => `സംശയമുണ്ടെങ്കിൽ ഇവിടെ ചോദിക്കൂ: ${c}.`,
  warningPointer: 'കടലാസിൽ ഒരു മുന്നറിയിപ്പ് ഉണ്ട്. അത് ശ്രദ്ധിച്ചു വായിക്കൂ.',
  rejectedNext: 'ഇതൊരു തെറ്റാണെന്ന് തോന്നുന്നെങ്കിൽ, ഈ കത്ത് അയച്ച ഓഫീസിൽ ചോദിക്കൂ.',
  lowQuality: 'ഫോട്ടോ അത്ര വ്യക്തമായിരുന്നില്ല, അതുകൊണ്ട് ചില വിവരങ്ങൾ തെറ്റായി വായിച്ചിരിക്കാം. ഒറിജിനൽ കടലാസുമായി ഒത്തുനോക്കൂ.',

  cardTodo: 'നിങ്ങൾ ചെയ്യേണ്ടത്',
  cardDates: 'പ്രധാന തീയതികൾ',
  cardAmount: 'തുക',
  cardWhere: 'എവിടെ പോകണം',
  cardWarnings: 'ശ്രദ്ധിക്കുക',
  cardDocs: 'വേണ്ട കടലാസുകൾ',
  cardPerson: 'ആരെക്കുറിച്ച്',
  cardFrom: 'അയച്ചത്',
  cardNumbers: 'സൂക്ഷിക്കേണ്ട നമ്പറുകൾ',
  cardContact: 'ബന്ധപ്പെടാൻ',
  refKinds: {
    application: 'അപേക്ഷ നമ്പർ',
    certificate: 'സർട്ടിഫിക്കറ്റ് നമ്പർ',
    consumer: 'കൺസ്യൂമർ നമ്പർ',
    account: 'അക്കൗണ്ട് നമ്പർ',
    case: 'കേസ് നമ്പർ',
    reference: 'കത്ത് നമ്പർ',
    registration: 'രജിസ്ട്രേഷൻ നമ്പർ',
    receipt: 'രസീത് നമ്പർ',
    other: 'നമ്പർ'
  },
  requiredDocNames: {
    aadhaar: 'ആധാർ കാർഡ്',
    pan: 'പാൻ കാർഡ്',
    ration_card: 'റേഷൻ കാർഡ്',
    voter_id: 'വോട്ടർ ഐഡി',
    passbook: 'ബാങ്ക് പാസ്ബുക്ക്',
    photo: 'ഫോട്ടോ',
    income_certificate: 'വരുമാന സർട്ടിഫിക്കറ്റ്',
    caste_certificate: 'ജാതി സർട്ടിഫിക്കറ്റ്',
    domicile_certificate: 'താമസ സർട്ടിഫിക്കറ്റ്',
    birth_certificate: 'ജനന സർട്ടിഫിക്കറ്റ്',
    land_record: 'ഭൂമി രേഖ',
    electricity_bill: 'കറന്റ് ബിൽ',
    address_proof: 'വിലാസം തെളിയിക്കുന്ന രേഖ',
    id_proof: 'തിരിച്ചറിയൽ രേഖ',
    affidavit: 'സത്യവാങ്മൂലം (അഫിഡവിറ്റ്)',
    application_form: 'അപേക്ഷ ഫോം'
  },

  voiceDownloadNote: 'ആദ്യമായി ശബ്ദം ഡൗൺലോഡ് ചെയ്യുന്നു (ഏകദേശം 58 MB). അതിനുശേഷം ഇന്റർനെറ്റ് ഇല്ലാതെയും പ്രവർത്തിക്കും.',

  listen: 'കേൾക്കൂ',
  pause: 'ഒന്ന് നിർത്തൂ',
  resume: 'തുടരൂ',
  stop: 'നിർത്തൂ',
  noVoice: 'ഈ ഫോണിൽ മലയാളം വോയ്സ് ഇല്ല.',
  noVoiceHint: 'ഫോൺ സെറ്റിംഗ്സിൽ (Text-to-speech) വോയ്സ് ചേർക്കാം, അല്ലെങ്കിൽ മറ്റൊരു ഭാഷയിൽ കേൾക്കാം.',
  listenInHindi: 'ഹിന്ദിയിൽ കേൾക്കൂ',
  listenInEnglish: 'ഇംഗ്ലീഷിൽ കേൾക്കൂ',
  noSpeechSupport: 'ഈ ബ്രൗസറിന് ഉറക്കെ വായിച്ചുതരാൻ കഴിയില്ല.',

  disclaimer: 'സമ്ഝോ നിങ്ങളുടെ കടലാസ് ലളിതമായി വിശദീകരിക്കുന്നു. പ്രധാന വിവരങ്ങൾ എപ്പോഴും ഒറിജിനൽ കടലാസുമായോ അത് നൽകിയ ഓഫീസുമായോ ഒത്തുനോക്കൂ. സമ്ഝോ ഒരു സർക്കാർ സേവനമല്ല. ഇത് നിയമോപദേശവുമല്ല.',
  fullText: 'സമ്ഝോ വായിച്ചത്',
  fullTextHint: 'നിറം കൊടുത്ത വരികൾ വ്യക്തമായി വായിക്കാനായില്ല.',
  newDocument: 'പുതിയ കടലാസ്',
  save: 'ഈ ഫോണിൽ സേവ് ചെയ്യൂ',
  saved: 'ഈ ഫോണിൽ സേവ് ചെയ്തു',
  share: 'ഷെയർ ചെയ്യൂ',
  copied: 'കോപ്പി ചെയ്തു',
  translateLines: 'കടലാസിലെ ഇംഗ്ലീഷ് വരികൾ മലയാളത്തിൽ കാണിക്കൂ',
  helperMode: 'സഹായി മോഡ്',
  helperModeHint: 'മറ്റുള്ളവർക്ക് കടലാസുകൾ വായിച്ചുകൊടുക്കുന്നവർക്ക് (CSC, NGO, സന്നദ്ധപ്രവർത്തകർ). ഇതിൽ സേവ് ഓഫ് ആയിരിക്കും, "അടുത്ത ആൾ" അമർത്തിയാൽ എല്ലാം മായും.',
  nextPerson: 'അടുത്ത ആൾ',
  listenMode: 'കേൾക്കൽ മോഡ്',
  listenModeHint: 'വിശദീകരണം തയ്യാറായാലുടൻ സമ്ഝോ അത് തനിയെ വായിച്ചുകേൾപ്പിക്കും.',
  settingsTitle: 'ക്രമീകരണങ്ങൾ',
  shareVoiceNote: 'വോയ്സ് നോട്ടായി അയയ്ക്കൂ',
  makingVoiceNote: 'വോയ്സ് നോട്ട് തയ്യാറാകുന്നു…',
  voiceNoteFailed: 'ഈ ഫോണിൽ വോയ്സ് നോട്ട് ഉണ്ടാക്കാൻ കഴിഞ്ഞില്ല.',
  translateOtherLines: 'കടലാസിലെ മറ്റു ഭാഷയിലെ വരികൾ മലയാളത്തിൽ കാണിക്കൂ',
  translateAiNote: 'ഇംഗ്ലീഷിൽ അല്ലാത്ത വരികൾ ഒരു AI സേവനം (Groq) ആണ് വിവർത്തനം ചെയ്യുന്നത്.',
  translateConsent: 'വിവർത്തനം ചെയ്യാൻ, ഈ വരികൾ ഇന്റർനെറ്റ് വഴി സമ്ഝോ സർവറിലേക്ക് അയയ്ക്കും. അവിടെ അവ സേവ് ചെയ്യില്ല. ആധാർ, ഫോൺ പോലുള്ള നമ്പറുകൾ ആദ്യം തന്നെ നീക്കം ചെയ്യും.',
  translateConfirm: 'ശരി, വിവർത്തനം ചെയ്യൂ',
  translating: 'വിവർത്തനം ചെയ്യുന്നു…',
  translateNote: 'മെഷീൻ വിവർത്തനം — തെറ്റുകൾ ഉണ്ടാകാം.',
  translateFailed: 'ഇപ്പോൾ വിവർത്തനം ലഭ്യമല്ല.',
  retryRotated: 'ഫോട്ടോ തിരിച്ച് വീണ്ടും വായിക്കൂ',

  addToCalendar: 'കലണ്ടറിൽ ഓർമ്മപ്പെടുത്തൽ ചേർക്കുക',
  askTitle: 'ഈ രേഖയെക്കുറിച്ച് ചോദിക്കുക',
  askHint: 'നിങ്ങളുടെ സ്വന്തം വാക്കുകളിൽ ചോദിക്കുക. സമ്ഝോ നിങ്ങളുടെ രേഖയിൽ നിന്ന് ഉത്തരം നൽകും — അതിൽ ഇല്ലെങ്കിൽ, സർക്കാർ വെബ്സൈറ്റുകളിൽ നിന്ന് മാത്രം.',
  askPlaceholder: 'നിങ്ങളുടെ ചോദ്യം എഴുതുക അല്ലെങ്കിൽ പറയുക…',
  askSend: 'ചോദിക്കുക',
  askMic: 'പറഞ്ഞ് ചോദിക്കുക',
  askListening: 'കേൾക്കുന്നു… ഇപ്പോൾ പറയുക',
  askWebToggle: 'ആവശ്യമെങ്കിൽ സർക്കാർ വെബ്സൈറ്റുകളും നോക്കുക',
  askConsent: 'ഉത്തരം നൽകാൻ, ഈ രേഖയിലെ എഴുത്തും നിങ്ങളുടെ ചോദ്യവും ഇന്റർനെറ്റ് വഴി സമ്ഝോ സർവറിലേക്കും ഒരു AI സേവനത്തിലേക്കും (Groq) അയയ്ക്കും. ആധാർ, പാൻ, ഫോൺ നമ്പർ, ഇമെയിൽ എന്നിവ ആദ്യം തന്നെ നീക്കം ചെയ്യും. ഒന്നും സേവ് ചെയ്യില്ല.',
  askOfficialOnly: 'സർക്കാർ വെബ്സൈറ്റുകൾ മാത്രമേ നോക്കൂ, ഉദാഹരണത്തിന്:',
  askConsentConfirm: 'ശരി, ചോദിക്കുക',
  askThinkingDoc: 'നിങ്ങളുടെ രേഖ വായിക്കുന്നു',
  askThinkingWeb: 'സർക്കാർ വെബ്സൈറ്റുകൾ നോക്കുന്നു',
  askFromDoc: 'നിങ്ങളുടെ രേഖയിൽ നിന്ന്',
  askFromWeb: 'സർക്കാർ വെബ്സൈറ്റിൽ നിന്ന്',
  askNotFound: 'ഇത് നിങ്ങളുടെ രേഖയിലോ സർക്കാർ വെബ്സൈറ്റുകളിലോ സമ്ഝോയ്ക്ക് കണ്ടെത്താനായില്ല. ഈ രേഖ അയച്ച ഓഫീസിനോട് ചോദിക്കുക.',
  askUnverified: 'ഇത് രേഖയിലെ കൃത്യമായ വരിയുമായി സമ്ഝോയ്ക്ക് ഒത്തുനോക്കാനായില്ല. രേഖ നോക്കി പരിശോധിക്കുക.',
  askSources: 'ഉറവിടങ്ങൾ',
  askOfficial: 'സർക്കാർ',
  askFailed: 'ഇപ്പോൾ ഉത്തരം കിട്ടിയില്ല. വീണ്ടും ശ്രമിക്കുക.',
  askBusy: 'ഇപ്പോൾ ധാരാളം ചോദ്യങ്ങൾ വരുന്നു. ഒരു മിനിറ്റ് കഴിഞ്ഞ് വീണ്ടും ചോദിക്കുക.',
  askAiNote: 'ഈ ഉത്തരങ്ങൾ AI എഴുതിയതാണ്, തെറ്റുകൾ ഉണ്ടാകാം. പ്രധാന കാര്യങ്ങൾ ഓഫീസിൽ ഉറപ്പുവരുത്തുക.',
  askTryNext: 'ഇതും ചോദിക്കാം:',
  askJump: 'ചോദ്യം ചോദിക്കുക',
  askSuggest: {
    fillForm: 'ഈ ഫോം എങ്ങനെ പൂരിപ്പിക്കാം? ഓരോ കോളവും വിശദീകരിക്കൂ.',
    first: 'ഞാൻ ആദ്യം എന്താണ് ചെയ്യേണ്ടത്?',
    deadline: 'അവസാന തീയതി കഴിഞ്ഞാൽ എന്തു സംഭവിക്കും?',
    pay: 'ഇത് എങ്ങനെ, എവിടെ അടയ്ക്കണം?',
    papers: 'ഈ രേഖകൾ എവിടെ നിന്ന് കിട്ടും?',
    rejected: 'ഇത് എന്തുകൊണ്ട് നിരസിച്ചു, ഇനി ഞാൻ എന്തു ചെയ്യാം?',
    meaning: 'ഈ രേഖ വളരെ ലളിതമായ വാക്കുകളിൽ വിശദീകരിക്കുക.',
    contact: 'ഇതിനെക്കുറിച്ച് ആരെ ബന്ധപ്പെടണം?',
    schemes: 'ഈ രേഖ അനുസരിച്ച് ഏതൊക്കെ സർക്കാർ പദ്ധതികൾക്ക് എനിക്ക് അർഹതയുണ്ടാകാം?'
  },

  helpTitle: 'സഹായം നേടുക',
  nearbyTitle: 'ഏറ്റവും അടുത്തുള്ള ഓഫീസ്',
  nearbyNote: 'നിങ്ങളുടെ അടുത്തുള്ള മാപ്പ് തുറക്കും. നിങ്ങളുടെ ലൊക്കേഷൻ മാപ്പിലേക്ക് മാത്രമേ പോകൂ — സമ്ഝോ അത് കാണുകയോ സേവ് ചെയ്യുകയോ ഇല്ല.',
  locating: 'നിങ്ങളുടെ ലൊക്കേഷൻ തിരയുന്നു…',
  schemesTitle: 'സർക്കാർ പദ്ധതികൾ',
  schemesText: 'ഈ രേഖ അനുസരിച്ച് ഏതൊക്കെ പദ്ധതികൾ നിങ്ങൾക്ക് പ്രയോജനപ്പെടാം എന്ന് സമ്ഝോയ്ക്ക് സർക്കാർ പദ്ധതി വെബ്സൈറ്റുകളിൽ നോക്കാം.',
  schemesButton: 'എനിക്കുള്ള പദ്ധതികൾ കണ്ടെത്തുക',
  legalTitle: 'സൗജന്യ നിയമ സഹായം',
  legalText: 'നിയമ സേവന അതോറിറ്റിയിൽ നിന്ന് നിങ്ങൾക്ക് സൗജന്യ വക്കീലിനെ ലഭിച്ചേക്കാം — ഉദാഹരണത്തിന് സ്ത്രീകൾ, കുട്ടികൾ, SC/ST, തൊഴിലാളികൾ, ഭിന്നശേഷിക്കാർ, കുറഞ്ഞ വരുമാനമുള്ളവർ.',
  legalCall: (n) => `${n} വിളിക്കുക (സൗജന്യം)`,
  legalNearby: 'ഏറ്റവും അടുത്തുള്ള നിയമ സേവന അതോറിറ്റി',
  legalMore: 'കൂടുതൽ നിയമ സഹായം',
  legalAskConsent: 'നിങ്ങളുടെ ചോദ്യം ഇന്റർനെറ്റ് വഴി സമ്ഝോ സർവറിലേക്കും ഒരു AI സേവനത്തിലേക്കും (Groq) അയയ്ക്കും; അവ ഉത്തരം സർക്കാർ വെബ്സൈറ്റുകളിൽ മാത്രമേ തിരയൂ. ആധാർ, പാൻ, ഫോൺ നമ്പർ, ഇമെയിൽ എന്നിവ ആദ്യം തന്നെ നീക്കം ചെയ്യും. ഒന്നും സേവ് ചെയ്യില്ല.',
  navLegal: 'നിയമ സഹായം'
}
